<template>
  <div>
    <v-timeline-item color="bluePcm" small>
      <v-card color="background">
        <v-row dense>
          <v-col cols="12">
            <v-card-title>
              Evento: Transferência Direta
            </v-card-title>
          </v-col>
        </v-row>
        <v-row align="center" align-content="center" dense>
          <v-col cols="4">
            <v-card-text> <strong>Status: </strong> {{ statusObject[`${evento.status}`] }} </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text>
              <strong>Data início: </strong>
              {{ timeToDate(evento.dateStartCall) }}
            </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text> <strong>Centro de Custo: </strong> {{ evento.centroDeCusto.description }} </v-card-text>
          </v-col>
        </v-row>
        <v-row align="center" align-content="center" dense v-if="evento.status === 'atendida'">
          <v-col cols="3">
            <v-card-text> <strong>Quem Transferiu: </strong> {{ evento.numeroOrigem }} </v-card-text>
          </v-col>
          <v-col cols="3">
            <v-card-text> <strong>Destino: </strong> {{ evento.numeroDestino }} </v-card-text>
          </v-col>
          <v-col cols="3">
            <v-card-text> <strong>Número Transferido: </strong> {{ evento.transferido }} </v-card-text>
          </v-col>
          <v-col cols="3">
            <v-card-text> <strong>Atendente: </strong> {{ verificaTronco(evento.atdCall) }} </v-card-text>
          </v-col>
        </v-row>
        <v-divider class="ma-2" />
        <v-row align="center" align-content="center" dense>
          <v-col cols="4">
            <v-card-text>
              <strong>Concluída: </strong>
              <v-icon v-if="evento.status == 'atendida'" color="success">
                mdi-check
              </v-icon>
              <v-icon v-else color="darkRed">mdi-close</v-icon>
            </v-card-text>
          </v-col>
          <v-col cols="4" v-if="evento.acao">
            <v-card-text> <strong>Ação: </strong> {{ showAcao(evento.acao) }} </v-card-text>
          </v-col>
          <Player
            v-if="
              ((evento.status === 'atendida' && evento.record.length > 0) ||
                (evento.status === 'naoAtendida' && evento.record.length > 0)) &&
                permissaoOuvirAudio
            "
            :file="getAudio(evento.record)"
            :archive="evento.record"
            downloadable
            color="primary"
          />
        </v-row>
      </v-card>
    </v-timeline-item>
  </div>
</template>

<script>
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import { listaRelatorioChamadasMethods } from '../_utils/listaRelatorioChamadasMethods'
import Player from './Player'

export default {
  name: 'TimeLineBlindTransfer',
  props: {
    evento: Object,
    isFrom: {
      type: String,
      default: '',
    },
  },
  components: { Player },
  data: () => ({
    statusObject: {
      atendida: 'Atendida',
      ocupado: 'Ocupado',
      acessoNegado: 'Acesso Negado',
      naoAtendida: 'Não Atendida',
      error: 'Erro',
      outros: 'Outros',
      pending: 'Pendente',
    },
    permissaoOuvirAudio: false,
    arrayPermissionCanHearAudioPesquisaSatisfacao: [
      process.env.VUE_APP_ADMINISTRADOR,
      process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_TOTAL,
      process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_OUVIR_GRAVACAO_HISTORICO,
    ],
    arrayPermissionCanHearAudioModulePabx: [
      process.env.VUE_APP_ADMINISTRADOR,
      process.env.VUE_APP_PABX_HABILITADO,
      process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_TOTAL,
      process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_OUVIR_GRAVACAO,
    ],
  }),

  created() {
    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    arrayPermissions.forEach(permissionLocalStorage => {
      if (this.isFrom && this.isFrom === 'pesquisaSatisfacao') {
        if (this.arrayPermissionCanHearAudioPesquisaSatisfacao.includes(permissionLocalStorage)) {
          this.permissaoOuvirAudio = true
        }
      } else {
        if (this.arrayPermissionCanHearAudioModulePabx.includes(permissionLocalStorage)) {
          this.permissaoOuvirAudio = true
        }
      }
    })
  },

  methods: {
    ...listaRelatorioChamadasMethods,
    ...obtainUserPermissions,
  },
}
</script>
